import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useMarketingMaterialContext() {
  const { marketingMaterials } = useContext<GlobalContextType>(GlobalContext);
  return marketingMaterials;
}
